import React, {useEffect, useState} from 'react';
import {Button, Grid, Header, Icon, Input, Label, Pagination, Segment, Table} from 'semantic-ui-react';
import {useNavigate} from "react-router-dom";
import moment from "moment/moment";
import {toast, ToastOptions} from "react-toastify";
import {SessionUser} from "../../../models/session-user";
import SessionStorage from "../../../store/session";
import {useBlockUI} from "../../../shared/services/block-ui-service";
import {Cliente} from "../../../models/cliente";
import {ClientFilter} from "../../../filters/client-filter";
import StringUtils from "../../../shared/utils/string-utils";
import {ToasterConfig} from "../../../config/ToasterConfig";
import useClientService from "../../../services/backoffice/hooks/useClientService";
import TooltipInfo from 'components/tooltip/tooltip';

const ClientsListPage = () => {
    const [clients, setClients] = useState<Cliente[]>([]);
    const [error, setError] = useState<string>();
    const [loading, setLoading] = useState<boolean>(false);
    const navigate = useNavigate();
    const [filter, setFilter] = useState<ClientFilter>()
    const [totalPages, setTotalPages] = useState<number>()
    const [sessionUser, setSessionUser] = useState<SessionUser>();
    const blockUI = useBlockUI();
    const {activateClient, inactivateClient, deleteClient, getClients} = useClientService();
    useEffect(() => {
        blockUI?.setActive(loading)
    }, [loading]);

    useEffect(() => {
        async function updateSessionUser() {
            const user = await SessionStorage.getSession();
            setSessionUser(user)
        }

        updateSessionUser()
    }, [])
    const [showFilters, setShowFilters] = useState(false);

    const toggleFilters = () => {
        setShowFilters(!showFilters);
    };
    useEffect(() => {
        listClients();
    }, [filter?.Page]);

    async function listClients() {
        setLoading(true)
        const response = (await getClients(filter).finally(() => setLoading(false)));
        setTotalPages(response.totalPages);
        setClients(response.itens);
    }

    const toggleActivationClient = async (client: Cliente, activate?: boolean) => {
        try {
            const result = window.confirm(`Tem certeza que deseja ${client.isActive ? 'desativar' : 'ativar'} o cliente ${client.nomeFantasia}?`);
            if (!result) return;
            setLoading(true);
            if (client) {
                const result = !client.isActive ? await activateClient(client.id) : await inactivateClient(client.id);
                if (!!result) {
                    toast.success(`O Cliente foi ${client.isActive ? 'desativado' : 'ativado'} com sucesso`, ToasterConfig.success);
                    listClients();
                }
            }
            setLoading(false);
        } catch (error: any) {
            toast.warn(`Falha ao ${client.isActive ? 'desativar' : 'ativar'} cliente`, ToasterConfig.error);
            setLoading(false);
            setError(error.message);
        }
    };

    async function deleteClienteFunction(cliente: Cliente) {
        try {
            const confirm = window.confirm(`Tem certeza que deseja apagar o cliente ${cliente.nomeFantasia}?`);

            if (confirm) {
                if (cliente) {
                    await deleteClient(cliente.id);
                    toast.success('Cliente deletado com sucesso', ToasterConfig.success as ToastOptions);
                    listClients();
                }
                setLoading(false);
            }
        } catch (error: any) {
            setLoading(false);
            setError(error.message);
        }
    }

    return (
        <div>
            <Header as="h3" textAlign="center" color={'green'}>
                Clientes
            </Header>
            <Table.Row>
                <Table.HeaderCell>
                    {sessionUser?.userData?.profile == 'Admin' &&
                        <Button color="green"
                                onClick={() => navigate('/backoffice/clients/create/')}>

                            <Icon name='plus'/> Novo
                        </Button>}
                </Table.HeaderCell>
                <Table.HeaderCell colSpan="4">
                    <Button onClick={toggleFilters} color={"green"}>
                        <Icon name={showFilters ? 'hide' : 'unhide'}/>
                        {showFilters ? 'Ocultar filtros' : 'Exibir filtros'}
                    </Button>
                </Table.HeaderCell>
            </Table.Row>
            {showFilters && (
                <Segment>
                    <Grid stackable doubling padded>
                        <Grid.Row>
                            <Grid.Column width={8}>
                                <label htmlFor="nomeFantasia">Nome Fantasia</label>
                                <Input
                                    fluid
                                    id="nomeFantasia"
                                    icon="search"
                                    type="text"
                                    placeholder="Nome Fantasia"
                                    value={filter?.nomeFantasia ?? ''}
                                    onChange={(event) =>
                                        setFilter({ ...filter, nomeFantasia: event.target.value })
                                    }
                                />
                            </Grid.Column>
                            <Grid.Column width={6}>
                                <label htmlFor="cnpj">CNPJ</label>
                                <Input
                                    fluid
                                    id="cnpj"
                                    icon="search"
                                    type="number"
                                    placeholder="CNPJ"
                                    value={filter?.cnpj ?? ''}
                                    onChange={(event) =>
                                        setFilter({ ...filter, cnpj: event.target.value })
                                    }
                                />
                            </Grid.Column>
                            <Grid.Column width={2} verticalAlign="bottom">
                                <Button color={"green"} onClick={listClients}>Buscar</Button>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Segment>
            )}


            <Table color={"green"}>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>#</Table.HeaderCell>
                        <Table.HeaderCell>Nome Fantasia</Table.HeaderCell>
                        <Table.HeaderCell>CNPJ</Table.HeaderCell>
                        <Table.HeaderCell>Criado em</Table.HeaderCell>
                        <Table.HeaderCell>Ativo</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>

                {(sessionUser?.userData?.profile == 'Admin' || 'Manager') &&
                    <Table.Body>
                        {clients?.map((client) => (
                            <Table.Row key={client.id}>
                                <Table.Cell>
                                    <Button.Group>
                                        {sessionUser?.userData?.profile === 'Admin' && (
                                            <TooltipInfo
                                                content="Editar cliente"
                                                trigger={
                                                    <Button
                                                        color="blue"
                                                        onClick={() => {
                                                            setLoading(true);
                                                            navigate('/backoffice/clients/edit/' + client.id);
                                                        }}
                                                        icon="edit"
                                                    />
                                                }
                                            />
                                        )}

                                        <TooltipInfo
                                            content="Ver motoristas do cliente"
                                            trigger={
                                                <Button
                                                    color="green"
                                                    onClick={() => {
                                                        setLoading(true);
                                                        navigate(`/backoffice/clients/drivers/?clientId=${client.id}`);
                                                    }}
                                                    icon="truck"
                                                />
                                            }
                                        />

                                        {sessionUser?.userData?.profile === 'Admin' && (
                                            <TooltipInfo
                                                content="Excluir cliente"
                                                trigger={
                                                    <Button
                                                        color="red"
                                                        onClick={() => deleteClienteFunction(client)}
                                                        icon="trash"
                                                    />
                                                }
                                            />
                                        )}

                                        {sessionUser?.userData?.profile === 'Admin' && (
                                            <TooltipInfo
                                                content={client.isActive ? "Desativar cliente" : "Ativar cliente"}
                                                trigger={
                                                    <Button
                                                        color={client.isActive ? 'red' : 'green'}
                                                        onClick={() => toggleActivationClient(client)}
                                                        icon={client.isActive ? 'power off' : 'power'}
                                                    />
                                                }
                                            />
                                        )}
                                    </Button.Group>

                                </Table.Cell>
                                <Table.Cell>{`${client.nomeFantasia}`}</Table.Cell>
                                <Table.Cell>{StringUtils.formatCNPJ(client.cnpj)}</Table.Cell>
                                <Table.Cell>{moment(client.createdAt).format('DD/MM/YY HH:mm')}</Table.Cell>
                                <Table.Cell>
                                    <Label key={client.id}
                                           color={!client.isActive ? 'red' : 'green'}>{client.isActive ? 'Sim' : 'Não'}</Label>
                                </Table.Cell>
                            </Table.Row>
                        ))}
                    </Table.Body>}
            </Table>
            <Pagination totalPages={totalPages ?? 0}
                        defaultActivePage={filter?.Page ?? 1}
                        onPageChange={(e, {activePage}) => {
                            setFilter({...filter, Page: activePage as number})
                        }
                        }>
            </Pagination>
        </div>
    );
};

export default ClientsListPage;
